import React from 'react'

import styles from './Button.module.scss'

const Button = () => {
  return (
    <button className={styles.button}>
      Стать учителем <br /> четвероного друга
    </button>
  )
}

export default Button
